let _playerColor = "#ED8B00";
let _backgroundColor = "#262626";
let _textColor = "#FFFFFF";
let _font = "Arial";

export function setPlayerColors() {
	const playerSelector = document.querySelector(".mediasite-player");

	if (playerSelector) {
		const playerStyle = getComputedStyle(playerSelector);
		playerColor(playerStyle.getPropertyValue('--player-primary-color').trim());
	}

	const modalSelector = document.querySelector(".video-js .mediasite-player__modal-dialog");

	if (modalSelector) {
		const modalStyle = getComputedStyle(modalSelector);
		backgroundColor(this, modalStyle.getPropertyValue('--modal-dialog-bg-color').trim());
		textColor(this, modalStyle.getPropertyValue('--modal-dialog-fg-color').trim());
	}
}

/**
* Updates the primary color from the player or returns the current saved value for the player
* @param {string} playerColor
* @return {string}
*/
export function playerColor(playerColor) {
	if (playerColor) {
		_playerColor = playerColor;
	} else {
		return _playerColor;
	}	
}

/**
* Updates the background color from the player or returns the current saved background value for the player
* @param {string} backgroundColor
* @return {string}
*/
export function backgroundColor(backgroundColor) {
	if (backgroundColor) {
		_backgroundColor = backgroundColor;
	} else {
		return _backgroundColor;
	}
}

/**
* Updates the text color from the player or returns the current saved value for the player
* @param {string} textColor
* @return {string}
*/
export function textColor(textColor) {
	if (textColor) {
		_textColor = textColor;
	} else {
		return _textColor;
	}
}

/**
* Updates the font or returns the saved font value
* @param {string} font
* @return {string}
*/
export function font(font) {
	if (font) {
		_font = font;
	} else {
		return _font;
	}
}